import labels from "@/labels/labels";
import { CommonLink, InfoPopup, MaterialIcon } from "../components";
import { useNavigate, useState, useEffect } from "@/common/hooks";
import Routes from "@/routes/RouteComponent";

const Navbar = ({
  type = "",
  layout = "",
  navHeader = "",
  redirectTo = () => {},
  isRiccAdministrator,
  accessProfileId,
  navCancelFunc,
  navCancelMessage,
  setNavCancelMessage,
  hideHamburger = false,
}) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Bootstrap lg
  const [adminOpen, setAdminOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
  };

  const toggleAdmin = () => {
    setAdminOpen(!adminOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Run once to ensure current state is correct
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const cancel = () => {
    if (navCancelFunc) {
      navCancelFunc();
      return;
    }

    if (navCancelMessage) {
      setShowPopup(true);
    } else {
      navigate(-1);
    }
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const handleSidebarRedirect = (path) => {
    redirectTo(path);
    setSidebarOpen(false);
  };

  const handleCloseSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarOpen]);

  if (layout === "closableLayout") {
    return (
      <section className="navbar closableLayout py-0" id="navbar">
        <header className="container title d-flex justify-content-center align-items-center ">
          <div className="col-4"></div>
          <div className="col-4 title d-flex justify-content-center text-center">
            {navHeader}
          </div>
          <CommonLink wrapperClassName="col-4 d-flex justify-content-end">
            <div onClick={cancel} className="cancel-button">
              {labels?.navbar?.cancel}
            </div>
          </CommonLink>
        </header>
        <InfoPopup
          showModal={showPopup}
          primaryButtonText={"Yes"}
          primaryButtonClick={() => {
            setNavCancelMessage("");
            setShowPopup(false);
            navigate(-1);
          }}
          secondaryButtonText={"No"}
          secondaryButtonClick={() => setShowPopup(false)}
          body={navCancelMessage}
        />
      </section>
    );
  } else {
    return (
      <section className="navbar" id="navbar">
        <header className="container title d-flex justify-content-between align-items-center py-3">
          {/* Mobile Hamburger */}
          {isMobile && !hideHamburger && (
            <div onClick={toggleSidebar}>
              <MaterialIcon iconName="menu" />
            </div>
          )}
          <div className="d-flex justify-content-center justify-content-md-start align-items-center">
            <div className="display-5 mb-0">{labels?.login?.title}</div>
            <span className="ms-2">&copy;</span>
          </div>
          {/* Placeholder for alignment */}
          {isMobile && <div style={{ width: 24 }} />}
          {!isMobile && type === "private" && (
            <div>
              <nav className="nav-items">
                <ul className="d-flex justify-content-between mb-0">
                  <li className="selected">{labels?.navbar?.products}</li>
                  <li id="owner" onClick={() => redirectTo("getOwnerInquiry")}>
                    {labels?.navbar?.owner}
                  </li>
                  {(isRiccAdministrator || accessProfileId === "4") && (
                    <li id="admin">
                      <span
                        data-bs-toggle="dropdown"
                        className="d-flex align-items-center"
                      >
                        {labels?.navbar?.admin}
                        <MaterialIcon
                          iconName="keyboard_arrow_down"
                          wrapperClassName="mt-2"
                        />
                      </span>

                      <ul className="dropdown-menu">
                        <div className="container ps-0">
                          <div className="p-5">
                            <li
                              onClick={() =>
                                redirectTo("approveNewAccessRequest")
                              }
                            >
                              <MaterialIcon
                                iconName="check_box"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.approveNewAccess}
                            </li>
                            {isRiccAdministrator && (
                              <>
                                <li
                                  onClick={() =>
                                    redirectTo("insuranceCompanies")
                                  }
                                >
                                  <MaterialIcon
                                    iconName="category"
                                    wrapperClassName="me-2 mt-1"
                                  />
                                  {labels?.navbar?.insuranceCompanies}
                                </li>
                                <li
                                  onClick={() =>
                                    redirectTo("investmentVehicles")
                                  }
                                >
                                  <MaterialIcon
                                    iconName="account_balance"
                                    wrapperClassName="me-2 mt-1"
                                  />
                                  {labels?.navbar?.investmentVehicles}
                                </li>
                                <li
                                  onClick={() =>
                                    redirectTo("productManufacturers")
                                  }
                                >
                                  <MaterialIcon
                                    iconName="inventory"
                                    wrapperClassName="me-2 mt-1"
                                  />
                                  {labels?.navbar?.productManufacturer}
                                </li>
                                <li onClick={() => redirectTo("recordKeepers")}>
                                  <MaterialIcon
                                    iconName="folder"
                                    wrapperClassName="me-2 mt-1"
                                  />
                                  {labels?.navbar?.recordKeeper}
                                </li>
                              </>
                            )}
                            <li
                              onClick={() =>
                                redirectTo("updateOperatorInformation")
                              }
                            >
                              <MaterialIcon
                                iconName="edit_square"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.updateOperatorInformation}
                            </li>
                          </div>
                        </div>
                      </ul>
                    </li>
                  )}
                  <li id="profile" className="pe-0 me-0">
                    <span
                      data-bs-toggle="dropdown"
                      className="d-flex align-items-center"
                    >
                      {labels?.navbar?.yourProfile}
                      <MaterialIcon
                        iconName="keyboard_arrow_down"
                        wrapperClassName="mt-2"
                      />
                    </span>

                    <ul className="dropdown-menu">
                      <div className="container ps-0">
                        <div className="p-5">
                          <li
                            onClick={() => redirectTo("profileChangePassword")}
                          >
                            <MaterialIcon
                              iconName="lock"
                              wrapperClassName="me-2 mt-1"
                            />
                            {labels?.navbar?.password}
                          </li>
                          <li onClick={() => redirectTo("updateContactInfo")}>
                            <MaterialIcon
                              iconName="person"
                              wrapperClassName="me-2 mt-1"
                            />
                            {labels?.navbar?.updateContactInfo}
                          </li>
                          {!isRiccAdministrator && (
                            <li onClick={() => redirectTo("updateAccessLevel")}>
                              <MaterialIcon
                                iconName="rule"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.updateAccessLevel}
                            </li>
                          )}
                        </div>
                      </div>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Mobile Sidebar */}
          {isMobile && (
            <>
              <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
                <div className="sidebar-content">
                  <div className="menuTitle">
                    <span> Menu</span>
                  </div>

                  <ul className="list-unstyled text-white">
                    <li>
                      <div className="d-flex align-items-center justify-content-between mt-3">
                        <span
                          onClick={() => navigate(Routes.dashboard.path)}
                          className="white-common-link cursor-pointer"
                        >
                          {labels?.navbar?.changeProductManufacturer}
                        </span>
                        <div
                          onClick={handleCloseSidebar}
                          className="cursor-pointer absolute-pos"
                        >
                          <MaterialIcon
                            iconName="close"
                            className="text-white"
                          />
                        </div>
                      </div>
                    </li>

                    <li className="">{labels?.navbar?.products}</li>
                    <li
                      className=""
                      onClick={() => handleSidebarRedirect("getOwnerInquiry")}
                    >
                      {labels?.navbar?.owner}
                    </li>
                    {isRiccAdministrator && (
                      <li id="admin-mobile" className="mobile-admin-dropdown">
                        <span
                          onClick={toggleAdmin}
                          style={{
                            userSelect: "none",
                            cursor: "pointer",
                            display: "flex",
                            fontWeight: 100,
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {labels?.navbar?.admin}
                          <MaterialIcon
                            iconName={
                              adminOpen
                                ? "keyboard_arrow_up"
                                : "keyboard_arrow_down"
                            }
                            wrapperClassName="ms-2"
                          />
                        </span>
                        {adminOpen && (
                          <ul className="mobile-dropdown-menu">
                            <li
                              onClick={() =>
                                handleSidebarRedirect("approveNewAccessRequest")
                              }
                            >
                              <MaterialIcon
                                iconName="check_box"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.approveNewAccess}
                            </li>
                            <li
                              onClick={() =>
                                handleSidebarRedirect("insuranceCompanies")
                              }
                            >
                              <MaterialIcon
                                iconName="category"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.insuranceCompanies}
                            </li>
                            <li
                              onClick={() =>
                                handleSidebarRedirect("investmentVehicles")
                              }
                            >
                              <MaterialIcon
                                iconName="account_balance"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.investmentVehicles}
                            </li>
                            <li
                              onClick={() =>
                                handleSidebarRedirect("productManufacturers")
                              }
                            >
                              <MaterialIcon
                                iconName="inventory"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.productManufacturer}
                            </li>
                            <li
                              onClick={() =>
                                handleSidebarRedirect("recordKeepers")
                              }
                            >
                              <MaterialIcon
                                iconName="folder"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.recordKeeper}
                            </li>
                            <li
                              onClick={() =>
                                handleSidebarRedirect(
                                  "updateOperatorInformation"
                                )
                              }
                            >
                              <MaterialIcon
                                iconName="edit_square"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.updateOperatorInformation}
                            </li>
                          </ul>
                        )}
                      </li>
                    )}

                    {/* In your mobile sidebar menu: */}
                    <li id="profile-mobile" className="mobile-profile-dropdown">
                      <span
                        onClick={toggleProfile}
                        style={{
                          userSelect: "none",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {labels?.navbar?.yourProfile}
                        <MaterialIcon
                          iconName={
                            profileOpen
                              ? "keyboard_arrow_up"
                              : "keyboard_arrow_down"
                          }
                          wrapperClassName="ms-2"
                        />
                      </span>
                      {profileOpen && (
                        <ul className="mobile-dropdown-menu">
                          <li
                            onClick={() =>
                              handleSidebarRedirect("profileChangePassword")
                            }
                          >
                            <MaterialIcon
                              iconName="lock"
                              wrapperClassName="me-2 mt-1"
                            />
                            {labels?.navbar?.password}
                          </li>
                          <li
                            onClick={() =>
                              handleSidebarRedirect("updateContactInfo")
                            }
                          >
                            <MaterialIcon
                              iconName="person"
                              wrapperClassName="me-2 mt-1"
                            />
                            {labels?.navbar?.updateContactInfo}
                          </li>
                          {!isRiccAdministrator && (
                            <li
                              onClick={() =>
                                handleSidebarRedirect("updateAccessLevel")
                              }
                            >
                              <MaterialIcon
                                iconName="rule"
                                wrapperClassName="me-2 mt-1"
                              />
                              {labels?.navbar?.updateAccessLevel}
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  </ul>

                  <div className="d-flex justify-content-center align-items-center logoutButton mt-4">
                    <span
                      onClick={() => navigate(Routes.logout.path)}
                      className=""
                    >
                      {labels?.navbar?.logout}
                    </span>

                    <h5 className="text-white">{labels?.navbar?.menu}</h5>
                  </div>
                </div>
              </div>

              {sidebarOpen && (
                <div
                  className="sidebar-backdrop"
                  onClick={handleCloseSidebar}
                ></div>
              )}
            </>
          )}
        </header>
      </section>
    );
  }
};

export default Navbar;
